<div *ngIf="scenario?.lessonplan" class="tab-pane fade show">
  <h5 style="display:inline-block">Lessonplan</h5>
  <button class="btn btn-primary" (click)="addLessonplanStep(null)" style="float:right;margin-top:10px;margin-bottom:10px">Add Step</button>
  <table class="table table-bordered">
    <thead>
      <tr>
        <th>Id</th>
        <th>Edit</th>
        <th>Name</th>
        <th>panelSectionId</th>
        <th>Description</th>
        <th>SequenceNo</th>
        <th>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of scenario.lessonplan">
        <td>{{l.id}}</td>
        <td><i class="bi bi-pencil" style="color:green" (click)="addLessonplanStep(l)"></i></td>
        <td>{{l.name}}</td>
        <td>{{l.panelSectionId}}</td>
        <td>{{l.description}}</td>
        <td>{{l.seqNo}}</td>
        <td><i class="bi bi-trash" style="color:orange" (click)="deleteLessonplanStep(l)"></i></td>
      </tr>
    </tbody>
  </table>
</div>

<!-- Modal Lessonplan Property ----------------------------------------------->
<div *ngIf="showLessonplanStepPropertyModal" #testmodal class="cpmodal">
  <div class="cpmodal-content">
    <div class="cpmodal-header">
      Choose a new unique lessonplan step id
    </div>
    <div class="inline"><sa-input-text [(text)]="lessonplanStep.id" [title]="'Property Name' "></sa-input-text></div>
    <button class="btn btn-primary" (click)="updateLessonplanStepProperty()">Update Component</button>
    <button class="btn btn-primary" style="float:right" (click)="showLessonplanStepPropertyModal = false">Cancel</button>
    <div class="spacer10"></div>
    <br>{{lessonplanStep| json}}
  </div>
</div>

<!-- Modal showLessonplanStepModal----------------------------------------------->
<div class="modal" tabindex="-1" [ngClass]="{show: showLessonplanStepModal}" [ngStyle]="{ display: showLessonplanStepModal ? 'block' : 'none' }">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header cp-soft-header" style="align-items:center;">
        <h5 class="modal-title" style="margin-right:auto;">Edit Lesson Plan Step</h5>
        <button type="button" class="btn btn-sm btn-outline-info" (click)="showLessonplanStepInfo = !showLessonplanStepInfo" style="margin-right:8px">
          <i class="bi bi-info-circle"></i>
        </button>
        <button type="button" class="btn-close" aria-label="Close" (click)="showLessonplanStepModal=false"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="showLessonplanStepInfo" class="alert alert-info" role="alert">
          <div><strong>How this works</strong></div>
          <ul style="margin-bottom:0;">
            <li>Fill in the Name, Sequence, and Description for the step.</li>
            <li>Set panelSectionId to link the step to a specific panel section.</li>
            <li>Toggle “Include UI” to add optional UI to this step.</li>
            <li>Interactivity Class: pick from the list to ensure names match your Virtex implementation.</li>
            <li>modalId: choose from the list to match existing modal IDs in your HTML.</li>
          </ul>
        </div>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">name</label>
            <input class="form-control" [(ngModel)]="lessonplanStep.name" />
          </div>
          <div class="col-md-6">
            <label class="form-label">domid</label>
            <input type="text" class="form-control" [(ngModel)]="lessonplanStep.domid" />
          </div>
          <div class="col-md-6">
            <label class="form-label">seqNo</label>
            <input type="number" class="form-control" [(ngModel)]="lessonplanStep.seqNo" />
          </div>
          <div class="col-md-6">
            <label class="form-label">panelSectionId (see index.html in virtex)</label><br>
            Either 	panelLessonplan or panelGeneralActivities
            <input type="text" class="form-control" [(ngModel)]="lessonplanStep.panelSectionId" />
          </div>
          <div class="col-md-6">
            <label class="form-label">class</label>
            <select class="form-select" [(ngModel)]="lessonplanStep.class" (ngModelChange)="onClassChanged($event)">
              <option value="LessonPlanStep">LessonPlanStep</option>
              <option value="LessonPlanStepUI">LessonPlanStepUI</option>
            </select>
            <small class="text-muted">Select 'LessonPlanStepUI' to include UI fields.</small>
          </div>
          <div class="col-12">
            <label class="form-label">Description</label>
            <textarea rows="3" class="form-control" [(ngModel)]="lessonplanStep.description"></textarea>
          </div>
        </div>

        <hr />

        <div class="form-check form-switch my-2">
          <input class="form-check-input" type="checkbox" id="hasUI" [(ngModel)]="hasUI" (ngModelChange)="onHasUIChanged($event)" />
          <label class="form-check-label" for="hasUI">Include UI (optional)</label>
        </div>

        <div *ngIf="hasUI" class="row g-3">
          <div class="col-md-4">
            <label class="form-label">Button Text</label>
            <input class="form-control" [(ngModel)]="lessonplanStep.buttonText" />
          </div>
          <div class="col-md-4">
            <label class="form-label">Interactivity Class</label>
            <div class="input-group">
              <input class="form-control" [(ngModel)]="lessonplanStep.interactivityClass" placeholder="e.g. ModalHandler" />
              <button class="btn btn-outline-secondary" type="button" (click)="showInteractivityClassList = !showInteractivityClassList">
                {{ showInteractivityClassList ? 'Hide' : 'Show' }}
              </button>
            </div>
            <div *ngIf="showInteractivityClassList" class="mt-2 border rounded p-2 bg-light">
              <small class="text-muted">Pick from the classes in the Interactivities folder in Virtex.(click to fill):</small>
              <ul class="list-unstyled mb-0">
                <li *ngFor="let c of allowedInteractivityClasses">
                  <a href="javascript:void(0)" (click)="pickInteractivityClass(c)">{{ c }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label">modalId</label>
            <div class="input-group">
              <input class="form-control" [(ngModel)]="lessonplanStep.modalId" placeholder="e.g. navigationModalId" />
              <button class="btn btn-outline-secondary" type="button" (click)="showModalIdList = !showModalIdList">
                {{ showModalIdList ? 'Hide' : 'Show' }}
              </button>
            </div>
            <div *ngIf="showModalIdList" class="mt-2 border rounded p-2 bg-light">
              <small class="text-muted">Pick an existing id (click to fill):</small>
              <ul class="list-unstyled mb-0">
                <li *ngFor="let m of allowedModalIds">
                  <a href="javascript:void(0)" (click)="pickModalId(m)">{{ m }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="showLessonplanStepModal=false">Close</button>
        <button class="btn btn-primary" (click)="saveLessonplanStep()">Save</button>
      </div>
    </div>
  </div>
</div>